export enum ApplicationStatus {
    OPEN = 'OPEN',
    CONSULTATION_SCHEDULED = 'CONSULTATION_SCHEDULED',
    AWAITING_OFFER = 'AWAITING_OFFER',
    OFFER = 'OFFER',
    COUNTEROFFER_CANDIDATE = 'COUNTEROFFER_CANDIDATE',
    COUNTEROFFER_CONSULTANT = 'COUNTEROFFER_CONSULTANT',
    OFFER_REJECTED = 'OFFER_REJECTED',
    OFFER_ACCEPTED = 'OFFER_ACCEPTED',
    // AWAITING_CANDIDATE_SIGNATURE = 'AWAITING_CANDIDATE_SIGNATURE',
    // AWAITING_CONSULTANT_SIGNATURE = 'AWAITING_CONSULTANT_SIGNATURE',
    // AWAITING_DOCUMENT_LIST = 'AWAITING_DOCUMENT_LIST',
    DOCUMENTS_IN_PROCESS = 'DOCUMENTS_IN_PROCESS',
    READY_FOR_SUBMISSION = 'READY_FOR_SUBMISSION',
    SUBMITTED = 'SUBMITTED',
    SUCCESS = 'SUCCESS',
    FAIL = 'FAIL',
    CLOSED = 'CLOSED',
}
